/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid2, Typography} from "@mui/material";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";
import {useFormulario} from "../../../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Pqrs from "../../../Formularios/Formulario_Pqrs";
import {guardarDoc} from "../../../../Servicios/BD/guardarDoc";
import {useLoaders} from "../../../../Modulo_Loaders/Hooks/useLoaders";
import logo from '../../../../Recursos/logo_redondo.svg'
import {useAvisos} from "../../../../Modulo_Avisos/Hooks/useAvisos";

const Formulario_Contactos_Home = () => {
    const {sCell, masSM} = useResponsive()
    const {props, obtenerEntidad, limpiarEntidad} = useFormulario({valoresDefecto: {}})
    const {Cargador, abrirCargador, cerrarCargador} = useLoaders({logo: logo})
    const {Avisos, nuevoAviso, terminar} = useAvisos({funcionUno: cerrarCargador, funcionDos: limpiarEntidad})

    const subirDatos = async () => {

        let entidad = await obtenerEntidad()
        entidad.fecha = new Date().getTime()
        entidad.estado = 'Nuevo'
        abrirCargador('Subiendo Datos')
        let result = await guardarDoc('pqrs', entidad)
        limpiarEntidad()
        nuevoAviso({aviso: 'Datos subidos'})
        cerrarCargador()

    }

    return (

        <Grid2
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{px: sCell ? 2 : 0}}
        >

            <Cargador/>

            <Avisos/>

            <Grid2 container justifyContent={'center'} size={{xs: 12, sm: 12, md: 9}}>


                <Grid2
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 9, md: 8}}
                    sx={{boxShadow: 4, borderRadius: 10, px: masSM ? 8 : 2, py: 8,}}>

                    <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography
                            sx={{fontSize: sCell ? 32 : 48, fontWeight: 800, textAlign: 'center', width: '100%'}}>
                            PQRS
                        </Typography>

                        <Typography
                            sx={{fontSize: sCell ? 16 : 20, textAlign: 'center', width: '100%', lineHeight: 1.3}}>
                            Hemos habilitado un formulario PQRS para que puedas enviarnos tus peticiones, quejas,
                            reclamos y
                            sugerencias de manera fácil y rápida, garantizando una atención oportuna y efectiva.
                        </Typography>

                    </Grid2>

                    <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 6}}>
                        <Formulario_Pqrs props={props}/>
                    </Grid2>

                    <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 3}}>
                        <Button
                            onClick={() => subirDatos()}
                        >Enviar</Button>
                    </Grid2>

                </Grid2>

            </Grid2>

        </Grid2>
    )

}
export default Formulario_Contactos_Home